import React from "react";
import { expandRange } from "../../helpers";
import { daysOrder, shortDays } from "../../constants";
import './serviceDays.scss'

interface ServiceDaysProps {
  openDaysRange: string | string[]; 
}

const ServiceDays: React.FC<ServiceDaysProps> = ({ openDaysRange }) => {
  const activeDays = expandRange(openDaysRange);

  return (
    <div className="service-days">
      {shortDays.map((short, idx) => {
        const fullDay = daysOrder[idx];
        const isActive = activeDays.includes(fullDay);

        return (
          <span key={short} className={`day ${isActive ? "active" : ""}`}>
            {short}
          </span>
        );
      })}
    </div>
  );
};

export default ServiceDays;
